'use strict';

module.exports = [
    {
        id: 'human-variome-project',
        logo: require('./img/hvp_logo.png'),
        url: 'http://www.humanvariomeproject.org',
        currentSupporter: false
    },
    {
        id: 'BRCA-Exchange',
        logo: require('./img/BRCA-Exchange-fat.jpg'),
        url: 'https://brcaexchange.org',
        currentSupporter: false
    },
    {
        id: 'ClinGen',
        logo: require('./img/clingen_logo.jpg'),
        url: 'https://clinicalgenome.org/',
        currentSupporter: false
    },
    {
        id: 'GA4GH',
        logo: require('./img/ga4gh-logo-more.png'),
        url: 'http://genomicsandhealth.org',
        currentSupporter: false
    },
    {
        id: 'ETHZurich',
        logo: require('./img/ETHzurich.png'),
        url: 'http://www.ethz.ch/en.html',
        currentSupporter: false
    },
    {
        id: 'UCSC',
        logo: require('./img/UC-Santa-Cruz-Genomics-Inst_090314.png'),
        url: 'http://ucscgenomics.soe.ucsc.edu',
        currentSupporter: false
    },
    {
        id: 'ENIGMA',
        logo: require('./img/enigma_logo.jpeg'),
        url: 'http://enigmaconsortium.org',
        currentSupporter: false
    },
    {
        id: 'LOVD',
        logo: require('./img/LOVD-hires.png'),
        url: 'http://www.lovd.nl/',
        currentSupporter: false
    },
    {
        id: 'GNOMAD',
        logo: require('./img/gnomad.png'),
        url: 'https://gnomad.broadinstitute.org/',
        currentSupporter: false
    },
    {
        id: 'BROTMAN',
        logo: require('./img/brotman_baty_institute_logo.jpg'),
        url: 'https://brotmanbaty.org/',
        currentSupporter: false
    }/*,
    {
        id: 'NIH',
        logo: require('./img/nih_bd2k_horizontal.png'),
        url: 'https://commonfund.nih.gov/bd2k',
        currentSupporter: true
    },
    {
        id: 'NCI',
        logo: require('./img/nci_orange.png'),
        url: 'https://www.cancer.gov/',
        currentSupporter: true
    },
    {
        id: 'ITCR',
        logo: require('./img/nci_itcr.png'),
        url: 'https://itcr.cancer.gov/',
        currentSupporter: true
    }*/
];
